// ©2024 Austin App House. All rights reserved.
import React from 'react';

const EstimatedTimeOverageLabel = ({
  text,
  cardClassName = '',
}) => (
  <div className="flex-box card-label-container">
    <div className={`card-label yellow-card-label ${cardClassName}`}>
      <svg width={20} height={20} xmlns="http://www.w3.org/2000/svg" fill='#ffff32' viewBox="0 0 640 640"><path d="M320 64C334.7 64 348.2 72.1 355.2 85L571.2 485C577.9 497.4 577.6 512.4 570.4 524.5C563.2 536.6 550.1 544 536 544L104 544C89.9 544 76.8 536.6 69.6 524.5C62.4 512.4 62.1 497.4 68.8 485L284.8 85C291.8 72.1 305.3 64 320 64zM320 416C302.3 416 288 430.3 288 448C288 465.7 302.3 480 320 480C337.7 480 352 465.7 352 448C352 430.3 337.7 416 320 416zM320 224C301.8 224 287.3 239.5 288.6 257.7L296 361.7C296.9 374.2 307.4 384 319.9 384C332.5 384 342.9 374.3 343.8 361.7L351.2 257.7C352.5 239.5 338.1 224 319.8 224z"/></svg>
      <span>{text}</span>
    </div>
  </div>
);

export default EstimatedTimeOverageLabel;
